import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import { between, Device, from, until } from '@helpers/media';
import CtaLinkStyles from '@stories/Components/CtaLink/CtaLink.styles';
import styled from 'styled-components';
import LinkListStyles from './LinkList/LinkList.styles';
const Container = styled.footer `
  border-top: 4px solid ${brand.green};
  padding-bottom: 80px;

  @media ${from(Device.DesktopSmall)} {
    border-width: 3px;
  }

  @media print {
    display: none;
  }
`;
const Inner = styled.div `
  ${siteWide};

  --siteWidth: 1550px;

  @media ${from(Device.TabletLarge)} {
    width: 100%;
    max-width: var(--maxWidth);
  }
`;
const FooterLogoWrapper = styled.div `
  display: grid;
  place-content: center;
  margin: 0 auto auto;

  &[data-mobile-only] {
    margin-bottom: 16px;

    @media ${from(Device.TabletLarge)} {
      display: none;
    }
  }

  &[data-desktop-only] {
    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }
`;
const FooterLogo = styled.img `
  aspect-ratio: 164 / 131;
  object-fit: contain;
  width: ${fluid(109, 164)};
`;
const MainWrapper = styled.section `
  display: flex;
  align-items: center;
  column-gap: ${fluid(32, 86)};
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  padding: ${fluid(50, 80)} 0 0;

  @media ${from(Device.TabletLarge)} {
    flex-direction: row;
    padding-bottom: ${fluid(0, 105)};
  }

  @media ${from(Device.Desktop)} {
    justify-content: space-between;
  }
`;
const LogoLink = styled.a `
  display: block;
  max-width: ${fluid(280, 398)};

  @media ${until(Device.TabletLarge)} {
    margin: 0 auto;
  }
`;
const Logo = styled.img `
  display: block;
`;
const LinksWrapper = styled.div `
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${Container}:has(${FooterLogoWrapper}) & {
    @media ${between(Device.TabletLarge, Device.DesktopSmall)} {
      flex-basis: 80%;
      justify-content: space-between;
    }
  }

  @media ${from(Device.TabletLarge)} {
    flex-direction: row;
    gap: ${fluid(32, 96)};
  }

  @media ${from(Device.DesktopSmall)} {
    justify-content: flex-end;
    flex: 1 0 0;
  }
`;
const ButtonsWrapper = styled.div `
  display: flex;
  gap: 24px;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;

  ${CtaLinkStyles.Container} {
    text-align: center;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 0;

    ${Container}:has(${FooterLogoWrapper}) & {
      align-items: flex-start;

      ${CtaLinkStyles.Container} {
        text-align: left;
      }
    }
  }

  @media ${from(Device.DesktopSmall)} {
    align-items: flex-start;
  }
`;
const LegalWrapper = styled.section `
  ${LinkListStyles.Container} {
    margin-bottom: ${fluid(16, 29)};
  }

  @media ${from(Device.TabletLarge)} {
    ${LinkListStyles.ListLink} {
      ${fonts.brandonGrotesque.bold};
      opacity: 0.4;

      &:hover {
        opacity: 1;
      }
    }
  }
`;
const LegalCopy = styled.div `
  ${fonts.brandonGrotesque.regular};
  font-size: ${fluid(10, 16)};
  line-height: ${fluid(15, 23)};
  opacity: 0.4;
`;
const FooterStyles = {
    ButtonsWrapper,
    Container,
    Inner,
    LegalCopy,
    LegalWrapper,
    LinksWrapper,
    Logo,
    LogoLink,
    MainWrapper,
    FooterLogoWrapper,
    FooterLogo,
};
export default FooterStyles;
